















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class VDeleteModal extends Vue {
  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }
}
